<template>
  <div class="cont-m" v-if="show">
    <h2>{{ license.type }}</h2>
    <z-license-status v-if="(license.status==3 || license.status==4 || license.status==5|| license.status==7)" :exception="(license.status==3 || license.status==4 || license.status==5|| license.status==7)" :reason="license.reason" :status="license.status"></z-license-status>
    <div class="clearfix"></div>
    <dl>
      <dd v-for="(ldata,ikey) in license.data" :key="ikey">
        <template v-if="ldata.formatter=='image'">
          <p :class="(ldata.status==3 || ldata.status==4 || ldata.status==5 || ldata.status==7)?'fontcolorredg':''" v-html="ldata.label + '：'"></p>
          <div :class="(ldata.status==3 || ldata.status==4 || ldata.status==5 || ldata.status==7)?'img-g280 left-left borredg':'img-g280 left-left borgaryg'" v-for="(img,imgkey) in ldata.value" :key="imgkey">
            <a class="zoom zoom-in" @click="HandlePreview(img)">
              <!--<img :src="img" width="180" height="210" alt="">-->
              <div v-if="!img.toLocaleLowerCase().includes('.pdf')" class="imgupload" :style="{backgroundImage: 'url(' + img + ')' }"></div>
              <div v-else class="imguploadPdf"></div>
            </a>
          </div>
          <div class="clearfix"></div>
        </template>
        <template v-else-if="ldata.formatter=='video'">
          <p :class="(ldata.status==3 || ldata.status==4 || ldata.status==5 || ldata.status==7)?'fontcolorredg':''" v-html="ldata.label + '：'"></p>
          <div :class="(ldata.status==3 || ldata.status==4 || ldata.status==5 || ldata.status==7)?'img-g280 left-left borredg':'img-g280 left-left borgaryg'" v-for="(video,videokey) in ldata.value" :key="videokey">
              <video class="imgupload" controls="controls" :src="video" autoplay></video>
          </div>
          <div class="clearfix"></div>
        </template>
        <template  v-else-if="ldata.formatter=='new-keys'">
          <div v-if="ldata.input.card_type==29">
            <z-record-number :disabled="true" :value="ldata.value" :input-card="ldata.input" :input-key="ldata.input.inputKey"></z-record-number>
          </div>
          <div v-else-if="ldata.input.card_type==30">
            <z-complex-text :disabled="true" :value="ldata.value" :options="ldata.input.options" :input-card="ldata.input" :input-key="ldata.input.inputKey"></z-complex-text>
          </div>
          <div v-else-if="ldata.input.card_type>30">
            <z-others :disabled="true" :value="ldata.value" :options="ldata.input.options" :input-card="ldata.input" :input-key="ldata.input.inputKey"></z-others>
          </div>
        </template>
        <template v-else><span v-html="ldata.label + '：'"></span><span class="license-value">{{ formatterValue(ldata.value) }}</span></template>
        <div class="clearfix" ></div>
      </dd>
    </dl>
    <z-layer ref="layer" :visible.sync="dialogVisible">
      <!--<img width="730" height="530" :src="dialogImageUrl" alt="">-->
      <div class="imgbigover" :style="{backgroundImage: 'url(' + dialogImageUrl + ')' }">
        <!--<img width="730 " height="530 " :src="dialogImageUrl " alt=" ">-->
      </div>
    </z-layer>
  </div>
</template>
<script>
/* eslint-disable */
import layer from "@/components/dialoglayer/Layer";
import RecordNumber from '@/components/form/RecordNumber'
import ComplexText from '@/components/form/ComplexText'
import Others from '@/components/form/Others'

import qs from 'qs';
import { getData } from "@/utils/utils";

export default {
  name: "LicenseDetail",
  props: {
    licenseData: {
      type: Object,
      default: () => {}
    },
    inputCard: {
      type: Object,
      default: () => {}
    },
    inputData: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    "z-layer": layer,
    'z-record-number': RecordNumber,
    'z-complex-text': ComplexText,
    'z-others': Others,
  },
  data: function() {
    return {
      dialogVisible: false,
      dialogImageUrl: "",
      show: true,
      license: {},
      type: 0
    };
  },
  watch: {
    licenseData: function(newData, oldData) {
      this.license = this.licenseData;
    }
  },
  created: function() {
    if (this.licenseData) {
      this.license = this.licenseData;
    }
    this.show = this.licenseData || (this.inputData && this.inputCard);
    this.setData();
    this.show = this.license.status !== 0;
  },
  mounted: function() {},
  methods: {
    HandlePreview: function(image) {
      if (image && !image.toLocaleLowerCase().includes(".pdf")) {
        this.dialogVisible = true;
        this.dialogImageUrl = image;
      }
      if (image && image.toLocaleLowerCase().includes(".pdf")) {
        let data = qs.parse(image.split("?")[1]);
        if(data && data.Expires){
          // 失效时间
          if(new Date().getTime() > String(data.Expires).padEnd(13,'0')){
            getData("/api/file/ssig/update", { url: image }, res => {
                if (res.code == 0) {
                  window.open(res.data,'_blank')
                } else {
                  window.location.reload()
                }
            },error => window.location.reload());
          }else {
            window.open(image,'_blank')
          }
        }else {
          window.open(image,'_blank')
        }
      }
    },
    setData: function() {
      if (this.inputData && this.inputCard) {
        this.license = {};
        this.$set(this.license, "type", this.inputCard.title);
        this.$set(this.license, "status", this.inputCard.status);
        this.type = 1;
        let data = [];
        for (let inputKey in this.inputCard.card_group) {
          let input = this.inputCard.card_group[inputKey];
          let value = this.inputData[inputKey];
          if (!value) continue;
          if (input.group_name) {
            if (input.card_type === 24) {
              // 单选框部分，将此值写入到标题中
              /* eslint-disable */
              for (let rkey in input.items) {
                if (input.items[rkey]["value"] == value) {
                  this.$set(this.license, "type", input.items[rkey].label);
                }
              }
            } else if (input.show) {
              data.push(this._setData(value, input,inputKey));
            }
          } else {
            data.push(this._setData(value, input,inputKey));
          }
        }
        this.$set(this.license, "data", data);
      }
    },
    _setData: function(value, input,inputKey) {
      if (input.card_type > 28) {
        return {
          value:JSON.parse(JSON.stringify(value)),//仅查看，不能修改值，深拷贝
          input:{...input,inputKey},
          formatter: "new-keys"
        }
      }else if (value instanceof Array) {
        if (input.card_type === 26 || input.card_type === 27) {
          let image = [];
          for (let key in value) {
            image.push(value[key].url);
          }
          return {
            label: input.label.content,
            value: image,
            formatter: input.card_type === 26 ? "image":"video"
          };
        }else{
          return { label: input.label.content, value: value.join("-") };
        }
      } else {
        return { label: input.label.content, value: value };
      }
      return false;
    },
    formatterValue: function(value) {
      if (isNaN(value)) {
        return value;
      }
      //处理不需要转换的数字
      var str = "" + value;
      if (!/e/i.test(str)) {
        return value;
      }
      return value
        .toFixed(18)
        .replace(/\.0+$/, "")
        .replace(/(\.\d+[1-9])0+$/, "$1");
    },
    formatterHttps: function(value) {
      return "//sinastorage.cn" + value.split(':/')[1] || value;
    }
  }
};
</script>
<style>
.panel-card {
  margin-top: 20px;
}

.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  visibility: hidden;
  clear: both;
}

.left-left {
  float: left;
}

.state .title-l {
  font-size: 18px;
  color: #2e334a;
  margin-right: 10px;
  margin-bottom: 20px;
  font-weight: bold;
}

.state .btn-120 {
  width: 120px;
  height: 38px;
  float: right;
  margin-bottom: 10px;
  margin-top: -7px;
}

.cont-m {
  padding: 8px 13px;
  line-height: 28px;
}

.padd9 h2 {
  font-size: 18px;
  color: #2e334a;
  margin-bottom: 30px;
  float: left;
  margin-right: 5px;
}

.padd9 h2 i {
  font-size: 14px;
  font-style: normal;
  color: #8a93b6;
}

.padd9 table {
  font-size: 14px;
}

.padd9 dl {
  font-size: 14px;
}

.padd9 dd {
  padding-bottom: 30px;
}

.padd9 .w-checkbox_checkbox__2qnpS {
  margin-top: 2px;
}

.imgbigover {
  width: 750px;
  max-height: 530px;
  overflow: hidden;
  margin: 0;
  padding-bottom: 90%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.img-g280 {
  margin-top: 5px;
  width: 280px;
  height: 210px;
  margin-right: 20px;
  position: relative;
}

.imgupload {
  width: 280px;
  height: 210px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
}

.imguploadPdf {
  width: 280px;
  height: 210px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 50%;
  background-color: #f9fafd;
  background-image: url('../../assets/PDF.png');
}

.inforg {
  padding: 20px 0 0;
}

.zoom {
  display: inline-block;
}

.zoom-in {
  cursor: zoom-in;
}

.zoom-out {
  cursor: zoom-out;
}

.borgaryg {
  border: 1px solid #cccccc;
}

.borredg {
  border: 1px solid #c83648;
}

.fontcolorredg {
  color: #c82439;
}

.license-value{
  max-width: 1060px;
  display: inline-block;
  word-wrap: break-word;
  word-break: break-word;
  vertical-align: top;
}
</style>



// WEBPACK FOOTER //
// src/components/detail/LicenseDetail.vue